import React from "react";
import { useNavigate } from "react-router-dom";
import { TabLayout } from "@/components/peeps/TabLayout";
import { ActivityFeed } from "@/components/peeps/ActivityFeed";
import { colors } from "@/lib/theme";
import logo from "@/assets/peeps-logo.png";

export default function Activity() {
  const navigate = useNavigate();
  return (
    <TabLayout>
      <div className="px-4 pt-6" data-testid="activity-page">
        <div className="flex items-center gap-3 mb-4">
          <button data-testid="home-peeps-button" onClick={() => navigate("/")} aria-label="Home" className="transition-transform active:scale-90">
            <img src={logo} alt="peeps" className="w-11 h-11 rounded-xl" />
          </button>
          <div>
            <p className="font-display font-medium text-[13px]" style={{ color: colors.brandSecondary }}>What's happening</p>
            <h1 className="font-display font-bold text-[26px]" style={{ color: colors.onSurface }}>Activity</h1>
          </div>
        </div>
        <ActivityFeed showHeading={false} />
      </div>
    </TabLayout>
  );
}
